import React from 'react';
import { DeviceDetailPage } from '../../../../../components/DeviceDetailPage';
import { useAppRoute } from '../../../../../hooks/app-route-hooks';

export const OverviewSiteDevicesDeviceDetails: React.FC = () => {
    const currentAppRoute = useAppRoute('OverviewSiteDevicesDeviceDetails');

    return (
        <DeviceDetailPage
            testId="site-details-all-devices-device-details-page"
            appRoute={{
                type: 'OverviewSiteDevices',
                locationId: currentAppRoute.locationId,
                siteId: currentAppRoute.siteId,
            }}
        />
    );
};
